var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScalesIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.436 62",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".scales_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "scales_icon_svg__a",
    d: "M30.313 9.817v39.48h5.656v-34.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scales_icon_svg__a",
    d: "M41.95 54.646H24.332v-5.355H41.95v1.365"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scales_icon_svg__a",
    d: "M15.177 54.645h35.922V60H15.177zM57.864 5.795H38.358M27.521 5.795H9.099M50.378 25.848l7.1-19.864 5.579 15.626M1.69 26.122l7.1-19.864 5.727 16.046M66.437 26.102a8.865 8.865 0 11-17.73 0zM17.73 27.068a8.865 8.865 0 01-17.73 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "scales_icon_svg__a",
    cx: 4.905,
    cy: 4.905,
    r: 4.905,
    transform: "translate(28.233)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScalesIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scales_icon.0f98380a52dd2d5b20603eff886202f8.svg";